import FeatureFlagged from 'components/featureflag/FeatureFlagged';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import { Control, Path, PathValue, SetFieldValue, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { FeatureFlag } from 'types/features';
import { InvoiceEmailFormBase } from 'types/invoices';
import { NamedEntityMinWithEmailDto } from 'types/other';

interface OfficeEmailSelectorProps<T extends InvoiceEmailFormBase> {
    control: Control<T>;
    setValue: UseFormSetValue<T>;
    getValues: UseFormGetValues<T>;
    options: NamedEntityMinWithEmailDto[];
}

export const OfficeEmailSelector = <T extends InvoiceEmailFormBase>({
    control,
    setValue,
    getValues,
    options,
}: OfficeEmailSelectorProps<T>) => {
    // SelectInput requires SetFieldValue (a looser RHF type) which TS can't
    // prove equivalent to UseFormSetValue<T> due to RHF generic invariance.
    const selectSetValue = setValue as SetFieldValue<T>;
    const invoicedByOfficeField = 'invoicedByOffice' as Path<T>;
    const replyToField = 'replyTo' as Path<T>;

    return (
        <FeatureFlagged flag={FeatureFlag.INVOICE_OFFICE_EMAIL} action={'show'}>
            <SelectInput<T, NamedEntityMinWithEmailDto>
                setValue={selectSetValue}
                control={control}
                label="invoices.email.from"
                required
                name={invoicedByOfficeField}
                onChange={(value) => {
                    if (value?.email) {
                        const currentReplyTo = (getValues(replyToField) ?? []) as string[];
                        if (currentReplyTo.length === 0) {
                            setValue(replyToField, [value.email] as PathValue<T, Path<T>>, { shouldDirty: true });
                        }
                    }
                }}
                options={options}
                getOptionLabel={(option) => option.name + ` (${option.email})`}
                getOptionIdentifier="id"
            />
        </FeatureFlagged>
    );
};
